import React, { useState, useEffect } from "react";
import ReactMarkdown from "react-markdown";
import { getFromDB } from "../../component/indexedDB/indexedDB";
import QuestionPublicLink from "../../component/PublicLink/PublicLink";
import styled from "styled-components";
import { QuizButton } from "../../types/GeneralStyles";
import {
  ResultScore,
  ResultScreen,
  WebpageItem,
  QuizResultDiv,
  QuizResultFlexContainer,
  GeneralData,
  QuizResultH2,
  QuizResultDescription,
  QuizResultScore,
  QuizEndResultText,
  LittleText,
  resetQuiz,
} from "../Webpage.components";
const Webpage = ({ result, oriQuiz, overViewPage, enableNavigationButton, resetQuiz }) => {
  const [answers, setAnswers] = useState({});
  const [attempts, setAttempts] = useState({});
  const [dbName, setDbName] = useState("");
  const [sortedQuestions, setSortedQuestions] = useState([]);
  const [databases, setDatabases] = useState([]);
  const [activeDatabase, setActiveDatabase] = useState("");

  // Fetch answers and attempts from IndexedDB when the component mounts
  useEffect(() => {
    // Enable the NavigationButton
    enableNavigationButton();
    const fetchAnswersAndAttempts = async () => {
      const dbName = sessionStorage.getItem("currentSessionName") || "Leerling";
      const data = await getFromDB(dbName);
      const answersMap = data.reduce((acc, item) => {
        acc[item.id] = item.answer;
        return acc;
      }, {});
      setAnswers(answersMap);
      const attemptsMap = data.reduce((acc, item) => {
        acc[item.id] = item.attempts;
        return acc;
      }, {});
      setAttempts(attemptsMap);
    };
    fetchAnswersAndAttempts();
  }, []); // Empty dependency array ensures this runs once when the component mounts

  // Sort questions based on component_order whenever result.component_order or oriQuiz.Quizes changes
  useEffect(() => {
    const sorted = result.component_order.map((orderItem) => {
      return oriQuiz.Quizes.find(
        (question) => question.quiz_item_id === orderItem.quiz_item_id
      );
    });

    setSortedQuestions(sorted);
    setDbName(sessionStorage.getItem("currentSessionName") || "Leerling");
  }, [result.component_order, oriQuiz.Quizes]); // Dependencies to rerun this effect
  return (
    <ResultScreen
      bgColor={result.theme_color}
      bgVisible={overViewPage}
      id={result.results_item_id}
    >
      <QuestionPublicLink
        overViewPage={overViewPage}
        type="result"
        quiz_item_id={result.results_item_id}
      />
      <ResultScore
        score={false}
        scoreVisible={false}
        endTotalScore={false}
        startCalculation={true}
      />
      <QuizResultFlexContainer>
        <QuizResultDiv
          borderInVisible="true"
          bgVisible={overViewPage}
          style={{ flex: "100%" }}
        >
          <GeneralData>
            <QuizResultH2>
              {dbName !== "Leerling" ? (
                <>
                  <LittleText>Gebruiker</LittleText>
                  {dbName}
                </>
              ) : null}
            </QuizResultH2>

            <QuizResultH2>
              <LittleText Align="right">Datum resultaten</LittleText>
              {new Date()
                .toLocaleDateString("nl-NL", {
                  hour: "2-digit",
                  minute: "2-digit",
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                })
                .replace(":", "u")}
            </QuizResultH2>
          </GeneralData>
        </QuizResultDiv>
        <QuizResultDescription
          bgColor={result.theme_color}
          style={{ flex: "100%" }}
        >
          <ReactMarkdown>{result.description}</ReactMarkdown>
        </QuizResultDescription>

        {sortedQuestions.map((question, index) => {
          const answer = answers[question.quiz_item_id] || [];
          const attempt = attempts[question.quiz_item_id] || [];
          return (
            <WebpageItem
              bgColor={result.theme_color}
              txtColor={result.theme_text_color}
              overViewPage={overViewPage}
              key={index}
              className={
                result.component_order[index].start_on_new_page ? "newPage" : ""
              }
              question={question}
              answer={answer}
              attempt={attempt}
            />
          );
        })}

        <QuizResultDiv bgVisible={overViewPage}>
          <QuizEndResultText>
            <span>
              <QuizResultScore>
              {dbName !== "Leerling" ? (
                      <>
                      <LittleText>Behaalde score</LittleText>
                      {dbName}
                      </>
                    ) : null}
              </QuizResultScore>
            </span>
            <span>
              <QuizResultScore>
                <LittleText Align="right">Totaal</LittleText>
                <ResultScore
                  score={false}
                  scoreVisible={true}
                  endTotalScore={true}
                />
                /{result.max_total_score}
              </QuizResultScore>
            </span>
          </QuizEndResultText>
        </QuizResultDiv>
       
      </QuizResultFlexContainer>
      {result.reset_quiz_button_visible === true && (
            <QuizButton
        className="screenVisible"
        bgColor={result.theme_color}
        txtColor={result.theme_text_color}
        onClick={resetQuiz} // Use resetQuiz directly
      >
        Start opnieuw
      </QuizButton>
      )}
    </ResultScreen>
    
  );
};

export default Webpage;
